module.exports = __webpack_public_path__ + "static/img/14000066.8444b204.png";